import { render, staticRenderFns } from "./ClassCardInfoSend.vue?vue&type=template&id=20c0b42a&scoped=true&"
import script from "./ClassCardInfoSend.vue?vue&type=script&lang=js&"
export * from "./ClassCardInfoSend.vue?vue&type=script&lang=js&"
import style0 from "./ClassCardInfoSend.vue?vue&type=style&index=0&id=20c0b42a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0b42a",
  null
  
)

export default component.exports